import * as React from 'react';
import { TextField, Grid, Box } from '@mui/material';
import { GridFormItem } from '../../GridForm';

import PhoneIcon from '@mui/icons-material/Phone';
import FaxIcon from '@mui/icons-material/Fax';
import EmailIcon from '@mui/icons-material/Email';

export interface PhoneFaxEmailViewProps {
    readOnly?:boolean;
    phone?:string;
    phoneLabel?:string;
    phoneDisabled?:boolean;
    fax?:string;
    faxLabel?:string;
    faxDisabled?:boolean;
    email?:string;
    emailLabel?:string;
    emailDisabled?:boolean;
    setField:(field:'phone'|'fax'|'email', value:string) => void;
}

const PhoneFaxEmailView = ({readOnly, phone, fax, email, phoneLabel, faxLabel, emailLabel,
    phoneDisabled, faxDisabled, emailDisabled, setField}:PhoneFaxEmailViewProps): JSX.Element => {
    return (<Box display="flex" alignItems="center" gap="2px" width="100%">
        {/* Phone */}
        <Box sx={{ minWidth: 50, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <PhoneIcon />
        </Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>
            <TextField
            name="ppePhone"
            label={phoneLabel || 'Phone'}
            value={phone}
            fullWidth
            disabled={phoneDisabled}
            onChange={(ev) => setField('phone', ev.target.value)}
            inputProps={{ readOnly }}
            variant="standard"
            />
        </Box>

        {/* Fax */}
        <Box sx={{ minWidth: 50, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <FaxIcon />
        </Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>
            <TextField
            name="ppeFax"
            label={faxLabel || 'Fax'}
            value={fax}
            fullWidth
            disabled={faxDisabled}
            onChange={(ev) => setField('fax', ev.target.value)}
            inputProps={{ readOnly }}
            variant="standard"
            />
        </Box>

        {/* Email */}
        <Box sx={{ minWidth: 50, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <EmailIcon />
        </Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>
            <TextField
            name="ppeEmail"
            label={emailLabel || 'Email'}
            value={email}
            fullWidth
            disabled={emailDisabled}
            onChange={(ev) => setField('email', ev.target.value)}
            inputProps={{ readOnly }}
            variant="standard"
            />
        </Box>
        </Box>
    );
}


export default PhoneFaxEmailView;
